import * as React from 'react';
import loading from '../assets/mobile-loading.gif';

export default function Loading() {
  return (
    <>
      <div className="mpi-dynamic-space-div"></div>
      <div className="mpi-content mpi-loading">
        <div>
          <div style={{textAlign: 'center'}}><img src={loading} alt="" className="mpi-unable-img"/></div>
        </div>
      </div>
    </>
  );
}